import React from "react";
import { useRouteError, Link } from "react-router-dom";
import { Button } from "./index";

/**
 * A component to display route errors in a user-friendly way
 */
const RouteErrorBoundary = () => {
  const error = useRouteError();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 text-red-500 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          {error?.status === 404 ? "Page Not Found" : "Something Went Wrong"}
        </h1>

        <p className="text-gray-600 dark:text-gray-300 mb-6">
          {error?.status === 404
            ? "The page you're looking for doesn't exist or has been moved."
            : "We're sorry, but we encountered an error while loading this page."}
        </p>

        {error?.message && (
          <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-800 rounded-md text-left">
            <p className="text-sm text-red-800 dark:text-red-300 font-mono">
              {error.message}
            </p>
          </div>
        )}

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Button variant="primary" onClick={() => window.location.reload()}>
            Try Again
          </Button>

          <Button variant="outline" as={Link} to="/dashboard">
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RouteErrorBoundary;
